import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import MerchantCard from '../../../shared/components/merchant-card';
import Heading from '../../../shared/components/heading';
import AppLoader from '../../../shared/components/app-loader';

import config from '../../../shared/services/config';
import AuthManager from '../../../shared/services/AuthManager';
import { isFunction } from 'lodash';
import Redirection from '../../../shared/services/redirection';
import { fetchOrCreatePlatformUser } from '../../../shared/actions/auth';
import { classNames } from '../../../shared/services/utils';
import Slider from 'react-slick';
import Raven from 'raven-js';
import MobileMerchantList from '../../../shared/components/mobile-merchants-list';

import * as AuthEvents from '../../../shared/constants/cleverTapEvents';
import cleverTap from '../../../shared/services/cleverTap';
import { PARTNER_STAFF_USER_ROLE } from '../../../shared/constants/strings';
import { CONSOLIDATED_DASHBOARD_ROLE_NAME } from '../../../shared/constants/roles';

class TeamAccounts extends React.Component {
  state = {
    errors: [],
    merchants: [],
    searchResults: [],
    error: undefined,
    message: undefined,
    showLoader: false,
    fetching: true,
    activeSlide: 1,
    slideSize: 4,
  };

  isMobile = window.matchMedia('(max-width: 576px)').matches;

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.shape({
      replace: PropTypes.func,
    }).isRequired,
    location: PropTypes.shape({
      state: PropTypes.object,
    }).isRequired,
    pageHeading: PropTypes.string,
    forMobile: PropTypes.bool,
  };

  redirectUser = async (merchant, source) => {
    if (source === 'selectedMID') {
      let userData = JSON.parse(localStorage.user);
      var [e1, e2] = userData.email.split('@');
    } else {
      var [e1, e2] = merchant.email.split('@');
    }
    let identifier = `${e1}+${merchant.mid}@${e2}`;
    let userProfile = {
      Name: merchant.name,
      Email: identifier,
      Phone: `+91${merchant.registered_mobile}`,
      Identity: identifier,
    };
    await cleverTap.onUserLogin({ Site: userProfile });
    await cleverTap.event(AuthEvents.LOGIN_INTO_BUSINESS, {
      Identity: identifier,
      'Email id': identifier,
      MID: merchant.mid,
      UUID: merchant.uuid,
      Role: merchant.acl_role_name,
    });
    const userData = {
      ...AuthManager.getUser(),
      ...this.merchantInfo(merchant),
    };
    AuthManager.persistUserToLocalStorage(userData);
    if (config.get('isTestModeEnabled')) {
      await AuthManager.createTestModeSession(userData?.product_account_uuid);
    }
    const loginRedirectUrl = config.get('loginRedirectUrl');
    if (isFunction(loginRedirectUrl)) {
      loginRedirectUrl(AuthManager.getUser(), true, Redirection.getURL());
    } else {
      this.props.history.push({
        pathname: loginRedirectUrl,
      });
    }
  };

  isAdmin = (merchant) => {
    const user = AuthManager.getUser();
    return (
      merchant.admin_user_id === user.id &&
      merchant.email.toLowerCase() === user.email.toLowerCase()
    );
  };

  isAdminMerchant = (merchants) => {
    if (merchants.every(this.isAdmin)) {
      return true;
    } else {
      return false;
    }
  };

  merchantInfo = (merchant) => {
    if (this.newMerchantData) {
      const { merchant_uuid: merchantUuid } = this.newMerchantData;
      if (merchantUuid === merchant.uuid) {
        return {
          ...this.newMerchantData,
        };
      }
    }
    return {
      is_tnc_accepted: true,
      mid: merchant.mid,
      profile_completed: true,
      new_merchant: this.newMerchant || false,
      business_origin: merchant.business_origin,
      product: merchant.product,
      merchant_uuid: merchant.uuid,
      type: merchant.type,
      dashboard_preference: merchant.dashboard_preference,
      merchant_account_uuid: merchant.merchant_account_uuid,
      product_account_uuid: merchant.uuid,
      partner_uuid: merchant.partner_uuid,
    };
  };

  renderCards = () => {
    const { searchResults, merchants } = this.state;
    const searchCount = searchResults.length;
    const settings = {
      infinite: false,
      speed: 500,
      arrows: false,
      variableWidth: true,
      slidesToShow: searchCount > 4 ? 4 : searchCount,
      afterChange: (current) => this.setState({ activeSlide: current + 1 }),
      slidesToScroll: this.state.slideSize,
    };

    return this.isMobile ? (
      <MobileMerchantList>
        {searchResults.map((merchant) => (
          <div
            className='card-container'
            key={`merchant-card-${merchant.uuid}`}
            onClick={() => this.onMIDselection(merchant, merchants)}
          >
            <MerchantCard
              key={`merchant-card-${merchant.id}`}
              merchant={merchant}
            />
          </div>
        ))}
      </MobileMerchantList>
    ) : (
      <Slider ref={(c) => (this.slider = c)} {...settings}>
        {this.state.searchResults.map((merchant) => (
          <div
            className='card-container'
            key={`merchant-card-${merchant.uuid}`}
            onClick={() => this.onMIDselection(merchant, merchants)}
          >
            <MerchantCard
              key={`merchant-card-${merchant.id}`}
              merchant={merchant}
            />
          </div>
        ))}
      </Slider>
    );
  };

  onMIDselection = async (merchant, merchantsList) => {
    let userData = JSON.parse(localStorage.user);
    await cleverTap.event(AuthEvents.MID_SCREEN_CLICKED, {
      'Button clicked': 'Business Selected',
      'Email id': userData.email,
      UUID: userData.uuid,
    });
    AuthManager.persistAclRoleNameToCookies(merchant.acl_role_name)
    AuthManager.persistConsolidatedProductAccountsToLocalStorage(
      merchant.acl_role_name == CONSOLIDATED_DASHBOARD_ROLE_NAME
      ? merchantsList
      : []
    )
    this.redirectUser(merchant, 'selectedMID');
  };

  searchMerchants = (searchKey) => {
    const { merchants } = this.state;
    const result = merchants.filter((merchant) => {
      return ['business_name', 'mid', 'acl_role_name'].some((key) => {
        if (!Boolean(merchant[key])) return false;
        return merchant[key]
          .toString()
          .toLowerCase()
          .includes(searchKey.toLowerCase().trim());
      });
    });
    this.setState({ searchResults: result });
  };

  merchantExists = () => {
    return this.state.merchants.length > 0;
  };

  componentWillMount() {
    const { history } = this.props;
    if (!AuthManager.isLoggedIn()) {
      window.location = '/app/account';
      return;
    }
    AuthManager.persistConsolidatedProductAccountsToLocalStorage([]);
  }

  shouldShowActions = () => {
    const { searchResults } = this.state;
    return !(searchResults.length <= this.state.slideSize) && !this.isMobile;
  };

  async componentDidMount() {
    this.fetchMerchantsForUser();
  }

  fetchMerchantsForUser = async (fetching = true) => {
    this.setState({ fetching });
    const fetchUserMerchants = config.get('fetchUserMerchants', () => {});
    const merchants = await fetchUserMerchants();
    AuthManager.persistProductAccountsToCookies(merchants);
    let hideWelcomePage = false,
      redirectionUrl = Redirection.redirectionURL,
      userData = JSON.parse(localStorage.user);
    if (redirectionUrl)
      hideWelcomePage = !!redirectionUrl.match(/\/oauth\/authorize/);
    if (userData && userData.is_gc_enabled) {
      hideWelcomePage = true;
    }
    if (merchants) {
      if (merchants.length > 0) {
        cleverTap.event(AuthEvents.LOGIN_SUCCESSFULL, {
          UUID: userData.uuid,
          'Email id': userData.email,
        });
      }
      const emailMerchants = this.filterAdminMerchants(merchants);
      if (emailMerchants.length === 0) {
        await this.addMerchant(true, 'direct');
      } else if (this.newMerchant && !hideWelcomePage) {
        let merchantData = this.newMerchantData;
        let [e1, e2] = merchantData.email.split('@');
        let identifier = `${e1}+${merchantData.mid}@${e2}`;
        let userProfile = {
          Name: merchantData.name,
          Email: identifier,
          Phone: `+91${merchantData.registered_mobile}`,
          Identity: identifier,
        };
        await cleverTap.onUserLogin({ Site: userProfile });
        await cleverTap.event(AuthEvents.LOGIN_INTO_BUSINESS, {
          Identity: identifier,
          'Email id': identifier,
          MID: merchantData.mid,
          UUID: merchantData.uuid,
          Role: merchantData.acl_role_name,
        });
        const loginRedirectUrl = config.get('loginRedirectUrl');
        loginRedirectUrl(AuthManager.getUser(), true, Redirection.getURL());
        // if (merchantData.is_cs_eligible && merchantData.cs_plan) {
        //   window.location = '/app/plans';
        // } else {
        //   window.location = '/app/assessment';
        // }
      } else if (
        emailMerchants.length === 1 &&
        this.isAdminMerchant(emailMerchants)
      ) {
        return this.redirectUser(emailMerchants[0], 'adminMerchant');
      }
      merchants.reverse();
      const consolidatedEmailMerchants = emailMerchants.filter(m => m.acl_role_name == CONSOLIDATED_DASHBOARD_ROLE_NAME)
      const nonConsolidatedEmailMerchants = emailMerchants.filter(m => m.acl_role_name != CONSOLIDATED_DASHBOARD_ROLE_NAME)
      this.setState({
        merchants: emailMerchants,
        searchResults: [
          ...(consolidatedEmailMerchants.length ? [{
            ...consolidatedEmailMerchants[0],
            totalMids: consolidatedEmailMerchants.length,
          }] : []),
          ...nonConsolidatedEmailMerchants,
        ],
      });
    } else {
      this.setState({ error: 'No Merchant is allotted' });
    }
    setTimeout(() => this.setState({ fetching: false }), 1500);
  };

  filterAdminMerchants = (merchants) => {
    const user = AuthManager.getUser();
    return [
      ...merchants.filter(
        (merchant) =>
          merchant.admin_user_id === user.id &&
          merchant.email.toLowerCase() === user.email.toLowerCase()
      ),
      ...merchants.filter(
        (merchant) =>
          merchant.admin_user_id !== user.id &&
          merchant.acl_role_name !== PARTNER_STAFF_USER_ROLE
      ),
    ];
  };

  addMerchant = async (showLoader = false, source) => {
    let userData = JSON.parse(localStorage.user);
    if (source === 'button') {
      await cleverTap.event(AuthEvents.MID_SCREEN_CLICKED, {
        'Button clicked': 'Create a new account',
        'Email id': userData.email,
        UUID: userData.uuid,
      });
    }
    localStorage.setItem('tempToken', localStorage.getItem('tokenData'));
    await this.createPlatformUser(showLoader);
  };

  createPlatformUser = async (fetching = true) => {
    const user = AuthManager.getUser();
    const email = user.email,
      {
        state: {
          whatsapp_consent = false,
          website_detail,
          monthly_expected_volume,
        } = {},
      } = this.props.location;
    try {
      this.setState({ showLoader: true, errors: [] });
      const ALLOWED_QUERY_PARAMS = config.get('ALLOWED_QUERY_PARAMS');
      let createMerchantPayload = {
        email,
        can_create: true,
        whatsapp_consent: whatsapp_consent,
        website_detail,
        monthly_expected_volume:
          (monthly_expected_volume && monthly_expected_volume.value) || 0,
      };
      if (ALLOWED_QUERY_PARAMS) {
        createMerchantPayload = {
          ...ALLOWED_QUERY_PARAMS,
          ...createMerchantPayload,
        };
      }
      this.newMerchantData = await fetchOrCreatePlatformUser(
        this.props.dispatch,
        createMerchantPayload,
        user.uuid
      );
      this.newMerchant = this.newMerchantData.new_merchant;
      this.fetchMerchantsForUser(fetching);
      if (this.slider) {
        this.slider.slickGoTo(0);
      }
      this.setState({ showLoader: false });
    } catch (err) {
      const response = err.errors;
      if (response && response.need_email_verification) {
        this.props.history.replace({
          pathname: '/account/email/otp',
          state: {
            ...this.props.location.state,
            allowSkip: false,
            shiftUuid: true,
          },
        });
      } else {
        Raven.captureException(err);
        this.setState({
          showLoader: false,
          errors: this.state.errors.concat(err.message),
        });
      }
    }
  };

  shouldRenderAddButton = () => {
    const { merchants } = this.state;
    const user = AuthManager.getUser();
    if (!user) return false;
    const email = user.email;
    return !merchants.some(
      (merchant) => merchant.email.toLowerCase() === email.toLowerCase()
    );
  };

  shouldShowSearch = () => {
    const { merchants } = this.state;
    return (
      (merchants.length > this.state.slideSize) || (this.isMobile && merchants.length > 3)
    );
  };

  currentStartOffset = () => {
    const { activeSlide } = this.state;
    return activeSlide;
  };

  currentEndOffset = () => {
    const { activeSlide, slideSize } = this.state;
    const lastOffset = activeSlide + slideSize - 1;
    if (lastOffset > this.state.searchResults.length) {
      return this.state.searchResults.length;
    }
    return activeSlide + slideSize - 1;
  };

  nextSlides = () => {
    this.slider.slickNext();
  };
  prevSlides = () => {
    this.slider.slickPrev();
  };

  singleUser = () => {
    return (
      !this.merchantExists() ||
      this.newMerchant ||
      this.isAdminMerchant(this.state.merchants)
    );
  };

  useDifferentAcc = async () => {
    let userData = JSON.parse(localStorage.user);
    await cleverTap.event(AuthEvents.MID_SCREEN_CLICKED, {
      'Button clicked': 'Use a different account',
      'Email id': userData.email,
      UUID: userData.uuid,
    });
    await cleverTap.event(AuthEvents.LOGOUT, {
      Email: userData.email,
    });
    localStorage.clear();
    window.location.href = '/app/account';
  };

  render() {
    // const mobile  = this.isMobile();
    const { showLoader, errors, searchResults, fetching } = this.state;
    const btnClassName = classNames({
      'is-loading': showLoader,
      'cmn-btn': true,
      'add-mid': true,
    });
    const hasError = errors.length !== 0;
    if (hasError) {
      return (
        <div className='container'>
          <h1 className='text-center pb-3'>'Error!'</h1>
          {React.Children.toArray(
            errors.map((err) => (
              <p className='error-message text-center'>{err}</p>
            ))
          )}
        </div>
      );
    } else {
      return (
        <div className='merchant-container'>
          {this.singleUser() ? '' : <Heading />}
          <div
            className={`container search-input ${
              this.shouldShowSearch() ? '' : 'd-none'
            }`}
          >
            <input
              placeholder='Search MID, Business Name..'
              type='text'
              onChange={(event) => this.searchMerchants(event.target.value)}
            />
          </div>
          <div className='container'>
            {this.shouldShowSearch() && !fetching ? (
              <span className='result-text'>
                {searchResults.length > 0
                  ? this.isMobile
                    ? `Showing ${searchResults.length} Results`
                    : `Results: Showing ${this.currentStartOffset()}-${this.currentEndOffset()} of ${
                        searchResults.length
                      }`
                  : 'Results: 0 of 0'}
              </span>
            ) : (
              ''
            )}
          </div>
          <div className='container cards-container'>
            {fetching || !this.merchantExists() ? (
              <AppLoader />
            ) : (
              this.renderCards()
            )}
          </div>
          {!fetching && this.merchantExists() ? (
            <div
              className={`actions ${this.shouldShowActions() ? '' : 'd-none'}`}
            >
              <span>
                <svg
                  onClick={this.prevSlides}
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='20'
                  viewBox='0 0 24 20'
                >
                  <path
                    fill='#212121'
                    fill-rule='nonzero'
                    d='M22.8 11.172H4.097l6.437 6.478a1.213 1.213 0 0 1 0 1.708 1.195 1.195 0 0 1-1.698 0l-8.484-8.54a1.217 1.217 0 0 1-.15-.184c-.02-.03-.034-.064-.051-.095-.02-.038-.043-.073-.059-.113-.017-.04-.027-.083-.039-.125-.01-.034-.022-.066-.03-.1A1.214 1.214 0 0 1 0 9.964V9.96c0-.078.008-.157.024-.234.007-.036.02-.07.03-.105.013-.04.022-.08.038-.12.017-.042.04-.08.062-.12.016-.029.03-.06.048-.088.044-.066.094-.128.15-.185L8.837.57a1.195 1.195 0 0 1 1.697 0 1.214 1.214 0 0 1 0 1.708L4.097 8.756H22.8c.663 0 1.2.54 1.2 1.208 0 .667-.537 1.208-1.2 1.208z'
                  />
                </svg>
              </span>
              <svg
                onClick={this.nextSlides}
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='20'
                viewBox='0 0 24 20'
              >
                <path
                  fill='#212121'
                  fill-rule='nonzero'
                  d='M1.2 11.172h18.703l-6.437 6.478a1.213 1.213 0 0 0 0 1.708 1.195 1.195 0 0 0 1.698 0l8.484-8.54c.056-.056.106-.118.15-.184.02-.03.034-.064.051-.095.02-.038.043-.073.059-.113.017-.04.027-.083.039-.125.01-.034.022-.066.03-.1.015-.079.023-.158.023-.237V9.96c0-.078-.008-.157-.024-.234-.007-.036-.02-.07-.03-.105-.013-.04-.022-.08-.038-.12-.017-.042-.04-.08-.062-.12-.016-.029-.03-.06-.048-.088a1.188 1.188 0 0 0-.15-.185L15.163.57a1.195 1.195 0 0 0-1.697 0 1.214 1.214 0 0 0 0 1.708l6.437 6.478H1.2c-.663 0-1.2.54-1.2 1.208 0 .667.537 1.208 1.2 1.208z'
                />
              </svg>
            </div>
          ) : (
            ''
          )}
          <div className='merchant-actions text-center'>
            {!this.singleUser() && (
              <button
                className='cmn-btn'
                onClick={() => this.useDifferentAcc()}
              >
                USE A DIFFERENT ACCOUNT
              </button>
            )}
            <div>
              {this.shouldRenderAddButton() &&
              !fetching &&
              !this.singleUser() ? (
                <a
                  className={btnClassName}
                  onClick={() => this.addMerchant(false, 'button')}
                >
                  {showLoader ? '' : 'CREATE A NEW ACCOUNT'}
                </a>
              ) : (
                <div />
              )}
            </div>
          </div>
        </div>
      );
    }
  }
}

export default connect()(TeamAccounts);
